import React from "react";

function DateInput({ value, onChange, label, resetValue }) {
  const handleDate = (e) => {
    onChange(e.target.value);
  };
  return (
    <div className="grigora-date-input flex items-center my-2 justify-between">
      {label && (
        <span className="grigora-date-input__label  text-grigora-base">
          {label}
        </span>
      )}

      <input
        className="bg-editor-input-selected border-none outline-none text-grigora-base py-1 "
        type="date"
        value={value}
        onChange={handleDate}
      />
    </div>
  );
}

export default DateInput;
